<script lang="ts">
  import QRCode from 'qrcode';
  import type { SignInLink } from '../api/types';
  import { clock } from '../utils/time';
  import { t } from '../i18n/index.ts';
  import { pieces } from './pieces';

  let { link }: { link: SignInLink } = $props();

  let qr = $state('');
  $effect(() => {
    QRCode.toDataURL(link.url, { margin: 1, width: 220 }).then((d: string) => (qr = d));
  });
</script>

<div class="flex flex-col items-center gap-3 text-center">
  <a class="btn btn-primary" href={link.url}><i aria-hidden="true" class="las la-mobile mr-1"></i>{t('componentsSignInOpenApp')}</a>
  {#if qr}
    <img src={qr} alt={t('componentsSignInQrAlt')} class="rounded-md bg-white p-2" width="220" height="220" />
  {/if}
  <p class="text-sm text-text-muted max-w-sm">
    {t('componentsSignInScan', { time: clock(link.expires_at) })}
  </p>
  <p class="text-sm text-text-muted max-w-sm">
    {#each pieces((a) => t('componentsSignInTypeIn', a), ['server', 'username']) as p, i (i)}{#if p.arg === 'server'}<strong class="text-text">{link.server_url}</strong>{:else if p.arg === 'username'}<strong class="text-text">{link.username}</strong>{:else}{p.text}{/if}{/each}
  </p>
</div>
